module.exports = __webpack_public_path__ + "img/home-images-01.111c5629.png";